<template>
	<h4>Berkas Pendaftar</h4>
	<div class="card shadow">
		<div class="card-header">
			<ul class="nav nav-tabs card-header-tabs">
				<li class="nav-item">
					<router-link to="/berkas" class="nav-link" active-class="active">Unggah</router-link>
				</li>
				<li class="nav-item">
					<router-link to="/berkas/kelengkapan" class="nav-link" active-class="active">Data Kelengkapan</router-link>
				</li>
			</ul>
		</div>
		<unggah-berkas v-if="!$route.params.tab" />
		<data-berkas v-else-if="$route.params.tab == 'kelengkapan'" />
		<not-found v-else class="card-body" />
	</div>
</template>

<script>
import UnggahBerkas from "@/components/UnggahBerkas";
import DataBerkas from "@/components/DataBerkas";
import NotFound from "@/components/NotFound";
export default {
	name: "SeragamView",
	components: {
		UnggahBerkas,
		DataBerkas,
		NotFound,
	},
	data() {
		return {};
	},
};
</script>

<style></style>
